import React, {Component} from "react"
import PropTypes from "prop-types"

import ShelfApi from "~/utils/ShelfApi"
import {
  Form,
  FormSection,
  Field,
  BooleanField,
  LoadingIndicator
} from "~/components/"
import {withTranslation} from "react-i18next"

const STATES = {
  LOADING: 0,
  LOADED: 1,
  ERROR: 2
}
class NewAreaView extends Component {
  constructor(props) {
    super(props)

    this.state = {
      area: false,
      state: STATES.LOADING
    }
  }

  componentDidMount() {
    if (this.props.match.params.area_id) {
      ShelfApi.get("/areas/" + this.props.match.params.area_id)
        .then(res => {
          this.setState({
            state: STATES.LOADED,
            area: {
              name: res.data.name,
              include_in_reports: res.data.include_in_reports
            }
          })
        })
        .catch(err => {
          this.setState({state: STATES.ERROR})
          console.log(err)
        })
    } else {
      this.setState({
        state: STATES.LOADED,
        area: {
          name: "",
          include_in_reports: true
        }
      })
    }
  }

  onSubmit(area) {
    if (this.props.match.params.area_id) {
      return ShelfApi.put(`/areas/${this.props.match.params.area_id}`, area)
    } else {
      return ShelfApi.post("/areas", area)
    }
  }

  render() {
    if (this.state.state === STATES.LOADING) {
      return <LoadingIndicator />
    } else if (this.state.state === STATES.ERROR) {
      return <p>{this.props.t("errorMessage")}</p>
    } else {
      return (
        <Form
          onSubmit={this.onSubmit.bind(this)}
          then={"/warehouse"}
          submitLabel={this.props.t("zones.detail.submit")}
          values={this.state.area}
        >
          <FormSection label={this.props.t("zones.detail.basic")}>
            <Field
              label={this.props.t("zones.detail.name")}
              type="Text"
              name="name"
            />
            <BooleanField
              label={this.props.t("zones.detail.includeInReports")}
              name="include_in_reports"
              value={this.state.area.include_in_reports}
              onChange={include_in_reports =>
                this.setState(state => ({
                  ...state,
                  area: {...state.area, include_in_reports}
                }))
              }
            >
              {this.props.t("yes")}
            </BooleanField>
          </FormSection>
        </Form>
      )
    }
  }
}

NewAreaView.propTypes = {
  match: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
}

export default withTranslation()(NewAreaView)



// WEBPACK FOOTER //
// ./src/views/NewAreaView.js